import React from 'react';
import LabeledCheckbox from '../LabeledCheckbox';
import PasswordForm from '../PasswordForm';

export type AccountCreateFormProps = {
  needAccountToCheckout: boolean;
  isPasswordRequired: boolean;
  isEmailRegistered?: boolean;
  onPasswordEntered: (value: string) => void;
  onRequiredChange: (isRequired: boolean) => void;
};

const AccountCreateForm: React.FC<AccountCreateFormProps> = ({
  needAccountToCheckout,
  isPasswordRequired,
  onPasswordEntered,
  onRequiredChange,
  isEmailRegistered = false,
}: AccountCreateFormProps) => {
  const handleCreateAccountChanged = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    onRequiredChange(e.target.checked);
  };

  const passwordFieldLabel = `To complete checkout, ${
    isEmailRegistered
      ? 'enter your account password below'
      : 'enter a password below to create an account'
  }${needAccountToCheckout ? '' : ' (OPTIONAL)'}`;

  return (
    <div className="flex flex-col">
      {!needAccountToCheckout && !isEmailRegistered ? (
        <LabeledCheckbox
          label="Save my information for a faster checkout"
          name="create-account"
          defaultChecked
          onChange={handleCreateAccountChanged}
        />
      ) : (
        <div className="ml-4 mt-2 text-xs">{passwordFieldLabel}</div>
      )}

      <PasswordForm
        enabled={needAccountToCheckout || isPasswordRequired}
        onPasswordEntered={onPasswordEntered}
      />
    </div>
  );
};

export default AccountCreateForm;
